import { render, staticRenderFns } from "./OrderDetailTD.vue?vue&type=template&id=5c09895c&scoped=true&"
import script from "./OrderDetailTD.vue?vue&type=script&lang=js&"
export * from "./OrderDetailTD.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailTD.vue?vue&type=style&index=0&id=5c09895c&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c09895c",
  null
  
)

export default component.exports